"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueSourcesImageSelector = exports.ValueSourceImage = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const PropertySelectors = __importStar(require("../react-properties-selector"));
exports.ValueSourceImage = styled_components_1.default.img `
  height: 16px;
  width: 16px;
`;
const unstyledDiv = (props) => React.createElement("div", { className: props.className }, props.children);
function comboBoxImageElement(_a) {
    var { isSelectedItemValid: _, locked: _1 } = _a, htmlProps = __rest(_a, ["isSelectedItemValid", "locked"]);
    return React.createElement("div", Object.assign({}, htmlProps), htmlProps.children);
}
function comboBoxImageOptionElementRow(_a) {
    var { isItemValid: _ } = _a, htmlProps = __rest(_a, ["isItemValid"]);
    return React.createElement("div", Object.assign({}, htmlProps), htmlProps.children);
}
const optionImageElementRow = (0, styled_components_1.default)(comboBoxImageOptionElementRow) `
  color: rgb(131, 131, 131);
  min-height: 18px;
  align-self: center;
  border: 0px none rgb(131, 131, 131);
  font: normal normal 300 normal 12px / 30px Helvetica, Arial, sans-serif;
  outline: rgb(131, 131, 131) none 0px;

  padding: 0.2em 0.5em;
  cursor: default;

  &:hover {
    background: rgba(203, 210, 246, 0.79);
    color: white;
  }

  ${props => (props.isItemValid === false ? "color: red;" : "")};
`;
exports.ValueSourcesImageSelector = PropertySelectors.createImageDropdownSelector({
    OptionImage: styled_components_1.default.img ``,
    OptionImageElementRow: optionImageElementRow,
    DropdownSelectElement: (0, styled_components_1.default)(unstyledDiv) `
      margin-left: -8px;
    `,
    ComboBoxImageButtonElement: (0, styled_components_1.default)(comboBoxImageElement) `
      /* width: 162px; */
      align-items: center;
      background: white;
      color: black;
      height: 19px;
      white-space: nowrap;
      border: 1px solid #b4b4b4;
      border-radius: 3px;
      font: normal normal 300 normal 12px / 30px Helvetica, Arial, sans-serif;
      outline: rgb(131, 131, 131) none 0px;
      padding: 0;
      display: inline-block;
      width: 31px;

      i {
        display: none;
      }

      span {
      }

      img {
        height: 16px;
        width: 16px;
        vertical-align: top;
        margin-top: 2px;
        margin-left: 7px;
      }
    `
});
//# sourceMappingURL=elements.js.map